<h1>Event Search</h1>
<!--  [tableBodyTemplate]="_tableBodyTemplate" -->
<rc-search-core 
    exportLabel="Events Search" 
    [dataType]="eventsDataType" 
    [validateSubmit]="false" 
    searchUI 
    *ngIf="showSearch">

</rc-search-core>   
<div *ngIf="lastClicked !== undefined">
    <app-event-modal 
        [(visible)]="showEditConfirmModal" 
        [eventData]="lastClicked"
        (onCancel)="showDeleteConfirmModal = false"
        (onSave)="resetState($event)"></app-event-modal>
</div>